<template>
    <el-dialog
            fullscreen
            :title="'选择用户'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :inline="true" :model="dataForm" ref="dataForm" @keyup.enter.native="getAdminList()">
            <el-form-item>
                <el-input v-model="dataForm.searchKey" placeholder="请输入关键字" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="getAdminList()">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="adminList"
                border
                v-loading="dataListLoading"
                style="width: 100%;">
            <el-table-column
                    fixed
                    type="index"
                    header-align="left"
                    align="left"
                    label="序号"
                    :index="getRowsIndex"
                    width="60"
            >
            </el-table-column>
            <el-table-column
                    fixed
                    prop="userName"
                    width="100"
                    header-align="left"
                    align="left"
                    label="用户名">
            </el-table-column>
            <el-table-column
                    fixed
                    prop="realName"
                    header-align="left"
                    align="left"
                    label="姓名">
            </el-table-column>
            <el-table-column
                    fixed
                    width="160"
                    prop="mobile"
                    header-align="left"
                    align="left"
                    label="联系手机">
            </el-table-column>
            <el-table-column
                    width="180"
                    prop="email"
                    header-align="left"
                    align="left"
                    label="email">
            </el-table-column>
            <el-table-column
                    fixed="right"
                    header-align="center"
                    align="center"
                    width="150"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small"  @click="selectAdminUser(scope.row.id)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dataForm:{
                    orgId:'',
                    searchKey: ''
                },
                dataListLoading: false,
                adminList:[],
                roleId:'',
                visible: false,
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                orgList:[]
            }
        },
        methods: {
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            resetForm() {
                this.$refs['dataForm'].resetFields();
            },
            init(roleId,orgId) {
                this.visible = true
                this.dataForm.orgId=orgId
                this.roleId=roleId
                this.$nextTick(() => {
                    this.resetForm()
                })
                this.getAdminList()
            },

            // 每页数
            sizeChangeHandle (val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getAdminList()
            },
            // 当前页
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getAdminList()
            },
            getAdminList() {
                let orgId= this.dataForm.orgId
                if(!orgId){
                    orgId='none'
                }
                let url = 'auth/employee/searchlist'
                let params = {
                    'page': this.pageIndex,
                    'rows': this.pageSize,
                    'searchKey': this.dataForm.searchKey,
                    'filter': {roleId: this.roleId,actionType:2,orgId:this.dataForm.orgId}
                }
                this.$http.post(url , params).then(({data}) => {
                    if (data && data.rows) {
                        this.adminList = data.rows
                        this.totalPage = data.totalItemCount
                    } else {
                        this.adminList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 表单提交
            selectAdminUser(id) {
                this.$http({
                    url: '/auth/role/authuser?roleId='+this.roleId+"&ids="+id,
                    method: 'post'
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '设置成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-select{
        width: 100%;
    }
</style>
